import React, { useState,useEffect,useContext } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import { ContextData } from '../../../../../context/Context';
import axios from 'axios';
import BioData from "../Forms/BioData";
import Education from "../Forms/Education";
import Origin from "../Forms/Origin";
import ParentsInfo from "../Forms/ParentsInfo";
import baseUrl from "../../../../../BaseURL";
import { toast } from "react-toastify";
import BankDetails from "../Forms/BankDetails";
import SocialInfo from "../Forms/SocialInfo";
import { useNavigate } from "react-router-dom";

export default function FormStep() {

  const [activeStep, setActiveStep] = React.useState(0);
  const steps = ["Bio Data", "Origin", "Parents Info", "Education", "Bank Details","Social Info" ];
  const [Data,setData] = useState(null)
  const {UserTokens,ReloadBioForms,setBioProgressStatus} = useContext(ContextData)

  const [formData, setFormData] = useState({
    bioData: {
      fname: "",
      lname: "",
      md_name:"",
      d_o_b: "",
      email: "",
      mobileNumber: "",
      picture:""
    },
    education: {
      matric_num: "",
      faculty: "",
      deparment: "",
      gpa: "",
      year_of_graduation: "",
      year_of_admission: "",
      course_of_study: "",
      nelfund_status: "",
      nelfund_indicator: "",
      manual_university: "",
      manual_university_state : ""
    },
    origin: {
      state_of_origin: "",
      local_government: "",
      home_address: "",
      city_town: ""
    },
    parentsInfo: {
      father_full_name: "",
      mother_full_name: "",
      guardian_valid_mobile: "",
    },

    bank: {
       bank_name : "",
       account_number : "",
       account_name : "",
        bvn_number : "",
        tin_number : "",
        nin_number : ""
    },
    social_info: {
       facebook_handle : "",
       instergram_handle : "",
       twitter_handle : ""
    } 
    


  });


  useEffect(()=>{
      

    async function FetchData(){
            //  setLoader(true)  

          try {
            const response = await axios.get(`${baseUrl}/auth/get_bio/${UserTokens}`,{
              withCredentials: true,
              headers: {
                'Accept' : 'application/json',
                'authorization': `Bearer`
              }}) 

              
             
         //   setData(response.data[0])
         setFormData((prev) => ({
          ...prev,
          bioData: {
            fname: response.data.bio_data[0]?.fname,
            md_name: response.data.bio_data[0]?.md_name,
            lname: response.data.bio_data[0]?.lname,
            d_o_b: response.data.bio_data[0]?.d_o_b,
            email: response.data.bio_data[0]?.email,
            mobileNumber: response.data.bio_data[0]?.mobileNumber,
            picture:response.data.bio_data[0]?.picture
          },
          origin: {
            state_of_origin: response.data.demography_data[0]?.state_of_origin,
            local_government: response.data.demography_data[0]?.local_gov,
            home_address: response.data.demography_data[0]?.home_address ,
            city_town: response.data.demography_data[0]?.city_town
          },
          parentsInfo: {  
            father_full_name: response.data.parent_data[0]?.father_full_name,
            mother_full_name: response.data.parent_data[0]?.mother_full_name,
            guardian_valid_mobile: response.data.parent_data[0]?.guardian_valid_mobile,
          },
          education: {
            matric_num: response.data.edu_data[0]?.matric_num,
            faculty: response.data.edu_data[0]?.faculty,
            deparment: response.data.edu_data[0]?.deparment,
            gpa: response.data.edu_data[0]?.gpa,
            university: response.data.edu_data[0]?.university,
            current_level : response.data.edu_data[0]?.current_level,
            year_of_graduation: response.data.edu_data[0]?.year_of_graduation,
            year_of_admission: response.data.edu_data[0]?.year_of_admission,
            course_of_study: response.data.edu_data[0]?.course_of_study,
            nelfund_status: response.data.edu_data[0]?.nelfund_status,
            nelfund_indicator: response.data.edu_data[0]?.nelfund_indicator,
            manual_university: response.data.edu_data[0]?.manual_university,
            manual_university_state : response.data.edu_data[0]?.manual_university_state, 
          },
          bank:{
             bank_name: response.data.bank_details_data[0]?.bank_name,
             account_number : response.data.bank_details_data[0]?.account_number,
             account_name : response.data.bank_details_data[0]?.account_name,
              bvn_number : response.data.bank_details_data[0]?.bvn_number,
              tin_number : response.data.bank_details_data[0]?.tin_number,
              nin_number : response.data.bank_details_data[0]?.nin_number
             
          },
           social_info:{
             facebook_handle : response.data.social_media_data[0]?.facebook_handle,
             instergram_handle : response.data.social_media_data[0]?.instergram_handle,
             twitter_handle : response.data.social_media_data[0]?.twitter_handle
          } ,
          verify_status: response.data.sign_up[0].verify_status
          
          

        }));
           

          } catch (err) {
             if(err) console.log(err.message)
            // setLoader(false)
          }

         
    }FetchData()


},[ReloadBioForms])


  // Handle Input Change
  const handleChange = (e, section) => {
    
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [section]: {
        ...prevData[section],
        [name]: value,
      },
    }));
    
  };


  const Navigate = useNavigate()

  const handleSubmit = () => {


          Navigate("/application/loan_application")

  };


  const handleNext = () => {


      if(activeStep === 1){
 
        if(formData.origin.home_address === "" || formData.origin.home_address === null){
          toast.error("Fill in the address input")
          return 
        }  

      }


      if(activeStep === 2){

         
       if(Object.keys(formData.parentsInfo).every((k) => formData.parentsInfo[k] ===  "") || Object.keys(formData.parentsInfo).every((k) => formData.parentsInfo[k] ===  null)){

        toast.error("Fill in the parents input")
         return
       }

      }

      
      if(activeStep === 3){
        
               if(Object.keys(formData.education).every((k) => formData.education[k] === "") || Object.keys(formData.education).every((k) => formData.education[k] === "")){
        
                toast.error("Fill in the education input")
                 return
               } 

      }

    setActiveStep((prev) => prev + 1);

  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const renderFormSection = () => {

    if (steps[activeStep]) {
      switch (activeStep) {
        case 0: 
          return <BioData verify_status={formData?.verify_status} formData={formData} handleChange={handleChange}  />;

          
          case 1:
            return  <Origin formData={formData} handleChange={handleChange} />
        case 2:
          return  <ParentsInfo formData={formData} handleChange={handleChange} /> 

        case 3:
          return (
             <Education formData={formData} handleChange={handleChange} />
          );

          case 4:
          return (
             <BankDetails formData={formData} handleChange={handleChange} />
          );
          case 5:
          return (
             <SocialInfo  formData={formData} handleChange={handleChange} />
          );

        default:
          return null;
      }
    }
    return null;
  }; 

  return (
   

    <div
      style={{ margin: "2rem auto", maxWidth: "700px", padding: "0 1.5rem" }}
    >
      <h1 className="mb-4 text-center">{steps[activeStep]}</h1>
        <p className="text-center pb-3">Student Bio Information</p>
         
      <Stepper id="form-stepper" activeStep={activeStep} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={index}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
   <p className="text-center pt-2 text-red-700">Enter N/A if the information is not available or not applicable</p>
      <div style={{ margin: "2rem 0" }}>{renderFormSection()}</div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          onClick={handleBack}
          disabled={activeStep === 0}
          variant="outlined"
          sx={{marginBottom:"20px"}} 
        >
          Back
        </Button>

        {activeStep < steps.length - 1 ? (
          <Button sx={{marginBottom:"20px"}} onClick={handleNext} variant="contained" color="primary">
            Next
          </Button>
        ) : (
          <Button sx={{marginBottom:"20px"}}   onClick={handleSubmit} variant="contained" color="primary">
            Go to Next Step
          </Button>
        )}
      </div>
       <div className="mt-10 text-center text-slate-400 text-xs md:text-sm">
        Powered by <span className="font-semibold text-slate-600">MastermindTech</span>
      </div>
    </div>
  );
}

